// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.knowledge-warning-title {
  margin: 0 0 10px 0;
  padding: 0;
}

.knowledge-warning-title h2 {
  margin: 0;
  font-size: 24px;
  color: #424242;
}

.knowledge-warning-message {
  margin: 0;
  color: #333;
  line-height: 1.4;
}

.knowledge-warning-actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/knowledgeWarningModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX","sourcesContent":[".knowledge-warning-title {\r\n  margin: 0 0 10px 0;\r\n  padding: 0;\r\n}\r\n\r\n.knowledge-warning-title h2 {\r\n  margin: 0;\r\n  font-size: 24px;\r\n  color: #424242;\r\n}\r\n\r\n.knowledge-warning-message {\r\n  margin: 0;\r\n  color: #333;\r\n  line-height: 1.4;\r\n}\r\n\r\n.knowledge-warning-actions {\r\n  margin-top: 20px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
